import { createShape } from './util';
export const Circle = createShape('circle', {
    attrs: {
        body: {
            refCx: '50%',
            refCy: '50%',
            refR: '50%',
        },
    },
});
//# sourceMappingURL=circle.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6/es/shape/circle.js
// module id = null
// module chunks = 